import PropTypes from 'prop-types';
// import { Leaf } from 'lucide-react';

const WorkspaceLogo = ({ title, subtitle, className = '' }) => {
  const safeTitle = String(title || '').trim();
  const dotIndex = safeTitle.indexOf('.');
  const brandName = dotIndex > -1 ? safeTitle.slice(0, dotIndex) : safeTitle;
  const brandSuffix = dotIndex > -1 ? safeTitle.slice(dotIndex + 1) : '';

  return (
    <div className={`flex items-center ${className}`}>
      <div
        className="inline-flex w-full items-center gap-2.5 rounded-2xl px-3 py-2 text-left ring-1 backdrop-blur-sm"
        style={{
          background: 'color-mix(in srgb, var(--workspace-surface) 94%, transparent)',
          borderColor: 'var(--workspace-border)',
          boxShadow: 'var(--workspace-shadow)'
        }}
      >
        {/* <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg">
          <Leaf
            aria-hidden="true"
            className="h-5 w-5"
            strokeWidth={2.4}
            style={{ color: 'var(--workspace-text-muted)' }}
          />
        </div> */}

        <div className="min-w-0 leading-none">
          <p
            className="font-command-display text-[0.95rem] font-bold tracking-[-0.04em]"
            style={{ color: 'var(--workspace-text)' }}
          >
            {brandName}
            {brandSuffix && (
              <span style={{ color: 'var(--workspace-accent-strong)' }}>.{brandSuffix}</span>
            )}
          </p>
          <p
            className="mt-1 font-command-label text-[8px] uppercase tracking-[0.24em]"
            style={{ color: 'var(--workspace-text-subtle)' }}
          >
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  );
};

WorkspaceLogo.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  className: PropTypes.string
};

WorkspaceLogo.defaultProps = {
  className: ''
};

export default WorkspaceLogo;
